import {Int} from '@store/@types/util';

const ordinalRules = new Intl.PluralRules('en', {
  type: 'ordinal',
});
const suffixes = {
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th',
};

export default function ordinalSuffix(num: Int) {
  const suffix = suffixes[ordinalRules.select(num)];
  return num + suffix;
}
